import HeaderContentsWithNoLink from '../../components/organism/headers/HeaderContentsWithNoLink'
export default {
  components: { HeaderContentsWithNoLink }
}
